module.exports = function() {
  return new Worker(__webpack_public_path__ + "dc2b1f0a43074b5a3dfe.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/tcode/motion.worker.js
// module id = Z43J
// module chunks = 6